import { idr } from "../../lib/api";

/** Petunjuk Kredit Retur untuk kasir (brief owner 22 Sep 2026, I1) — keadaan
 *  dari `hooks/useKreditRetur`. Dipakai Input Nota & Input Penjualan.
 *
 *  Tanpa petunjuk ini kreditnya cuma catatan di database: kasir tidak tahu
 *  pelanggan punya kredit, dan pelanggan yang lupa kehilangan uangnya (owner
 *  26 Agu). Nominal HANYA ditampilkan kalau nama + No HP cocok — nominal
 *  menyiratkan "bisa dipakai". Tidak ada potongan digit nomor lain: pertanyaan
 *  "nomor Bapak berakhiran 789?" cukup diiyakan orang lain bernama sama.
 *  `data-testid="nota-kredit-pelanggan"` dipertahankan dari versi lama.
 */
export default function PetunjukKreditRetur({ info }) {
  if (!info) return null;
  if (info.keadaan === "cocok") {
    return (
      <p className="text-[11px] text-violet-700 mt-1" data-testid="nota-kredit-pelanggan">
        Pelanggan ini (nama + No HP) punya <b>kredit retur {idr(info.sisa)}</b> — bisa dipakai
        dengan metode pembayaran &quot;Kredit Retur&quot;.
      </p>
    );
  }
  if (info.keadaan === "perlu_hp") {
    return (
      <p className="text-[11px] text-amber-800 mt-1" data-testid="nota-kredit-perlu-hp">
        Ada kredit retur atas nama ini. Isi No HP pelanggan (sama dengan nota retur asal) untuk
        memeriksa apakah bisa dipakai — kredit hanya milik nama DAN No HP yang sama.
      </p>
    );
  }
  if (info.keadaan === "hp_lain") {
    return (
      <p className="text-[11px] text-amber-800 mt-1" data-testid="nota-kredit-beda-hp">
        Ada kredit retur atas nama ini, tapi terdaftar dengan No HP lain — tidak bisa dipakai dengan
        No HP ini. Kalau pelanggan sudah ganti nomor, SPV/approver retur bisa memindahkannya di
        Retur › Kredit Pelanggan (pelanggan wajib membawa struk retur atau menyebut No HP lamanya).
      </p>
    );
  }
  return null;
}
